import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=b59d983a&scoped=true&"
import script from "./orders.ts?vue&type=script&lang=ts&"
export * from "./orders.ts?vue&type=script&lang=ts&"
import style0 from "./orders.scss?vue&type=style&index=0&id=b59d983a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59d983a",
  null
  
)

export default component.exports